/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/* eslint-disable @atlaskit/design-system/use-tokens-space */
import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';
import React from 'react';
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

import { fg } from '@confluence/feature-gating';

type WrapperProps = ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps;

const HubRendererWrapperOld =
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	styled.div({
		// removing 96 gutter (akEditorBreakoutPadding) width by appling negative margin
		// this increases the width of extension by 96px
		// we have to adjust this value
		// in Editor we adds 40px in the same way
		// to compensate the difference we limit the width of extension to
		// 704px - default (800 - 96)
		// 955px - wide (1051 - 96)
		// 1744px - full width (1840 - 96)
		'& .ak-renderer-document, & [data-multibodiedextension-container]': {
			'& > div.ak-renderer-extension': {
				padding: '0 48px',
				'& > div.ak-renderer-extension-overflow-container': {
					margin: '0 -48px',
				},
			},
			'& > div.ak-renderer-extension[data-layout=default]': {
				// extensions with default layout should have 800px max-width
				// for screens larger than 736px we limit the max-width to 704px -> 704+48*2 = 800
				// for screens smaller than 736px we limit the max-width to 100% - 32px -> 100% - 32 + 48*2 = 100% + 64(page padding) -> full width
				maxWidth: 'min(704px, calc(100% - 32px))',
				// positioning extension with default layout in the center
				// in the same way as we do for wide and full-width extensions
				marginLeft: '50%',
				transform: 'translateX(-50%)',
			},
			'& > div.ak-renderer-extension[data-layout=wide]': {
				maxWidth: '955px',
			},
			'& > div.ak-renderer-extension[data-layout=full-width]': {
				maxWidth: '1744px',
			},
		},

		// This override is removing the marging between MBEs (Sections and any other future MBE extensions)
		'[data-multiBodiedExtension-container] + [data-multiBodiedExtension-container]': {
			'& > .ak-renderer-extension': {
				marginTop: 0,
			},
		},

		// Removing the margin between MBE and any extension
		'[data-multiBodiedExtension-container] + div.ak-renderer-extension': {
			marginTop: 0,
		},

		// Removing the margin between any extension and MBE
		'div.ak-renderer-extension + [data-multiBodiedExtension-container]': {
			'& > .ak-renderer-extension': {
				marginTop: 0,
			},
		},

		// Removing the margin between any extensions
		'div.ak-renderer-extension + div.ak-renderer-extension': {
			marginTop: 0,
		},
	});

const HubRendererWrapperNew =
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	styled.div({
		// removing 96 gutter (akEditorBreakoutPadding) width by appling negative margin
		// this increases the width of extension by 96px
		// we have to adjust this value
		// in Editor we adds 40px in the same way
		// to compensate the difference we limit the width of extension to
		// 704px - default (800 - 96)
		// 955px - wide (1051 - 96)
		// 1744px - full width (1840 - 96)
		'div.ak-renderer-extension[data-top-level]': {
			padding: '0 48px',
			'& > div.ak-renderer-extension-overflow-container': {
				margin: '0 -48px',
			},
		},

		'div.ak-renderer-extension[data-top-level][data-layout=default]': {
			// extensions with default layout should have 800px max-width
			// for screens larger than 736px we limit the max-width to 704px -> 704+48*2 = 800
			// for screens smaller than 736px we limit the max-width to 100% - 32px -> 100% - 32 + 48*2 = 100% + 64(page padding) -> full width
			maxWidth: 'min(704px, calc(100% - 32px))',
			// positioning extension with default layout in the center
			// in the same way as we do for wide and full-width extensions
			marginLeft: '50%',
			transform: 'translateX(-50%)',
		},
		'div.ak-renderer-extension[data-top-level][data-layout=wide]': {
			maxWidth: '955px',
		},
		'div.ak-renderer-extension[data-top-level][data-layout=full-width]': {
			maxWidth: '1744px',
		},

		// Removing the top margin so there are no gaps between consecutive macros on the Company Hub
		'& .ak-renderer-extension': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
			marginTop: '0 !important',
		},
	});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HubRendererWrapper: ComponentType<WrapperProps> = (props) => {
	return fg('confluence_frontend_margin_gap_removal') ? (
		<HubRendererWrapperNew {...props} />
	) : (
		<HubRendererWrapperOld {...props} />
	);
};
